module.exports = __webpack_public_path__ + "media/images/svg/logos_footer-45491ffec60024f1d03b34d3b708f0a7.svg";